// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAjm_zdSGCgmEGKYXUuhYzW6u17bmLlLkk",
  authDomain: "orebro-app.firebaseapp.com",
  projectId: "orebro-app",
  storageBucket: "orebro-app.appspot.com",
  messagingSenderId: "900423046149",
  appId: "1:900423046149:web:d6b1b82337413cc1ee786c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app)